import { motion } from "framer-motion";
import { Palette, Zap, Shield, Globe, Smartphone, Moon } from "lucide-react";

const features = [
  {
    icon: Palette,
    title: "100% à votre image",
    description: "Couleurs, typographies, contenu — tout est personnalisé pour refléter votre identité professionnelle.",
  },
  {
    icon: Globe,
    title: "Bilingue FR/EN",
    description: "Switch automatique français/anglais intégré. Idéal pour toucher une audience internationale.",
  },
  {
    icon: Zap,
    title: "Ultra rapide",
    description: "Chargement instantané, animations fluides, performances optimisées au maximum.",
  },
  {
    icon: Moon,
    title: "Dark & Light Mode",
    description: "Thème sombre et clair avec transition fluide. Vos visiteurs adorent.",
  },
  {
    icon: Smartphone,
    title: "Mobile first",
    description: "Parfait sur mobile, tablette et desktop. Installable comme une application.",
  },
  {
    icon: Shield,
    title: "SEO au top",
    description: "Référencement optimisé pour Google — vous êtes visible dès la mise en ligne.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i: number) => ({
    opacity: 1, y: 0,
    transition: { delay: i * 0.08, duration: 0.5, ease: "easeOut" as const },
  }),
};

const SellFeatures = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-accent/[0.02] to-transparent" />
      <div className="container mx-auto px-6 relative">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Fonctionnalités
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4">
            Tout ce qu'il faut pour{" "}
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              sortir du lot
            </span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Chaque détail a été pensé pour maximiser votre impact auprès de vos visiteurs
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {features.map((feature, i) => (
            <motion.div
              key={feature.title}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
              className="group p-7 rounded-2xl bg-card/60 backdrop-blur-sm border border-border/50 hover:border-primary/40 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary/15 to-accent/15 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-bold text-lg mb-2">{feature.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SellFeatures;
